import fetchApi from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapCampaignClosedReason = mapDictionaryState;

const campaignClosedReasonApi = createDictionaryApiFactory("campaignClosedReason");

export const getCampaignClosedReason = campaignClosedReasonApi.search;

export const getCampaignClosedReasonSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/campaignClosedReason/select`) as SelectItemDto[];
    return response;
}